import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setParts, setCacheTab, setCacheAssemblies, setCacheParts, setCacheSearchType } from '../../redux/rulesSlice';
import { initializeAuth, getRelatedParts } from '../../services/apiService';
import { useMsal } from "@azure/msal-react";
import SearchType from './SearchType';

function parseSearch(searchText) {
  const searchParm = searchText.split(':').map(item => item.trim());
  if (isNaN(searchParm[1]) || searchParm[0] === 'BasePart')
    return  `AttrName : "${searchParm[0]}", AttrValue : "${searchParm[1]}"`;
  else
    return  `AttrName : "${searchParm[0]}", AttrValue : ${searchParm[1]}`;
}

const Search = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [cntAssemblies, setCntAssemblies] = useState(0);
  const [cntParts, setCntParts] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { cacheSearch, cacheTab, cacheSearchType } = useSelector(state => state.rules);
  const assembliesBlue = cacheTab === 'assemblies' ? 'headerBlue borderBlue' : '';
  const partsBlue = cacheTab === 'parts' ? 'headerBlue borderBlue' : '';


  useEffect(() => {
    if (cacheSearch != '') {
      dispatch(setCacheSearchType('WhereUse'));
      setSearchText(cacheSearch);
      getCacheSearch(cacheSearch, 'WhereUse');
    }
  }, [cacheSearch]);
  
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  }
  const getAssemblies = (json) => {
    return json.filter(elem => elem.keyData.includes('ChildBOMCollection'));
  }
  const getParts = (json) => {
    return json.filter(elem => elem.keyData.includes('BasePart'));
  }

  const handleSearch = () => {
    getCacheSearch(searchText, cacheSearchType);
  };

  const getCacheSearch = async(search, type) => {
    if (search.trim()) {
      setLoading(true);
      setErrorMessage('');
      dispatch(setParts([]));
      await initializeAuth(instance, accounts);
      try {
        const searchString = search.includes(':') ? parseSearch(search) : search.trim();
        const response = await getRelatedParts(searchString, type);
        console.log("Fetched Tree:", response);
        const assembies = getAssemblies(response);
        const parts = getParts(response);
        dispatch(setCacheAssemblies(assembies));
        dispatch(setCacheParts(parts));
        setCntAssemblies(assembies.length);
        setCntParts(parts.length);
      } catch (error) {
        console.error("Failed to fetch tree:", error);
        const status = error.response?.status;
        setErrorMessage(
          status === 401 || status === 403
            ? 'CacheTool denied access. Please sign in again or contact your administrator.'
            : 'Unable to retrieve related parts. Please try again.'
        );
      } finally {
        setLoading(false);
      }
    }
  };
  const handleCacheTab = (tab) => {
    if (cacheTab != tab)
    {
      dispatch(setCacheTab(tab));
    }
  };

return (
  <div className="justify-between px-4 py-2 border-b bg-gray-50">
        <div className="flex space-x-2 mb-2">
            <SearchType />
            <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyUp={handleKeyUp}
                className="border p-2 rounded"
                placeholder="Enter part number..."
            />
            <button
              onClick={handleSearch}
              className="bg-blue-500 text-white px-4 rounded hover:bg-blue-600"
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
        </div>
      {errorMessage && <p role="alert" className="text-red-600 mb-2">{errorMessage}</p>}
      <button onClick={() => handleCacheTab('assemblies')} className={`px-4 text-left  ${assembliesBlue}`}>Assemblies{(cntAssemblies > 0) ? ` (${cntAssemblies})` : ''}</button>
      <button onClick={() => handleCacheTab('parts')} className={`px-4 text-left  ${partsBlue}`}>Parts{(cntParts > 0) ? ` (${cntParts})` : ''}</button>
  </div>
);
};

export default Search;
